import { useState } from 'react'
import './Contact.css'
import socialsImage from '../assets/Taha Wairua socials.jpg'

function Contact() {
  const [showEmailOptions, setShowEmailOptions] = useState(false)
  const email = 'georgia@tahawairua.org'
  const phone = '+64 021-02527591'
  const contactName = 'Georgia Armstrong'

  const subject = encodeURIComponent('Taha Wairua Enquiry')
  const body = encodeURIComponent('Hi Georgia,')

  const openGmail = () => {
    window.open(
      `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
        email,
      )}&su=${subject}&body=${body}`,
      '_blank',
      'noopener,noreferrer',
    )
    setShowEmailOptions(false)
  }

  const openOutlook = () => {
    window.open(
      `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(
        email,
      )}&subject=${subject}&body=${body}`,
      '_blank',
      'noopener,noreferrer',
    )
    setShowEmailOptions(false)
  }

  return (
    <div className="contact-page">
      <div className="contact-container">
        <img
          src={socialsImage}
          alt="Taha Wairua socials"
          loading="lazy"
          className="contact-socials-image"
        />
        <div className="contact-details-panel">
          <h2>Contact Us</h2>
          <div className="contact-details">
            <div className="contact-item">
              <strong>Name:</strong>
              <p>{contactName}</p>
            </div>
            <div className="contact-item">
              <strong>Email:</strong>
              <p>{email}</p>
            </div>
            <div className="contact-item">
              <strong>Phone:</strong>
              <p>{phone}</p>
            </div>
          </div>
          <button
            type="button"
            className="contact-button"
            onClick={() => setShowEmailOptions((isOpen) => !isOpen)}
          >
            Contact Us
          </button>
          {showEmailOptions && (
            <div className="email-client-picker">
              <p className="email-client-title">
                Choose your preferred email client:
              </p>
              <div className="email-client-actions">
                <button
                  type="button"
                  className="email-client-button"
                  onClick={openGmail}
                >
                  Gmail
                </button>
                <button
                  type="button"
                  className="email-client-button"
                  onClick={openOutlook}
                >
                  Outlook
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Contact
